import { settleInstallment } from "@api/stores/salesInvoices/installments/settleInstallment/api";
import { settleInstallments } from "@api/stores/salesInvoices/installments/settleInstallments/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  ISalesInvoiceInstallmentsGetAllParams,
  ISalesInvoiceInstallmentsResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ISalesInvoiceInstallmentsResponse>>,
  IPathBaseParam,
  IPaginationParams & ISalesInvoiceInstallmentsGetAllParams
>("stores.salesInvoices.installments");

const getApis = createGetApi<
  IApiResponse<ISalesInvoiceInstallmentsResponse>,
  IPathByIdParam,
  object
>("stores.salesInvoices.installments");

export const installments = {
  ...getAllApis,
  ...getApis,
  settleInstallments,
  settleInstallment,
};
